import { environment } from 'Public_old/src/environments/environment';
import { EventEmitter, Injectable } from '@angular/core';
import { SpaContext } from '../Classes/spacontext';
import { SpaLogger } from '../Common/Classes/Global/spalogger.class';
import { AuthContextService } from '../Services/authContext.service';
import { SpaEventService } from '../Services/spaEvents.service';
import { Messaging } from './Models/Messaging/messaging.models';

@Injectable()
export class MessagingInjectable {
	totalUnreadMessages = 0;
	currentActive: number | null = null;

	conn: xsockets.client;
	ws: xsockets.controller;

	reconectAttempts = 0;

	/**
	 * returns current messages when new messages has been sent from server.
	 */
	onMessages: EventEmitter<Messaging.CaseMessagesSocketModel> = new EventEmitter<Messaging.CaseMessagesSocketModel>();
	/**
	 * returns all messages sent in a case, is triggered by first asking for getMessages by caseId.
	 */
	onGetMessages: EventEmitter<Messaging.CaseMessagesSocketModel> = new EventEmitter<Messaging.CaseMessagesSocketModel>();
	/**
	 * returns current ReadUntil time, is triggered by first setting SetReadUntil.
	 */
	onHasReadUntil: EventEmitter<Messaging.HasReadUntilSocketModel> = new EventEmitter<Messaging.HasReadUntilSocketModel>();

	onCaseClosed = new EventEmitter<number>();
	onAllowClient = new EventEmitter<Messaging.AllowClientResponseChangedModel>();

	// Return CaseId of case that completed a form
	onCompletedForm = new EventEmitter<number>();
	/**
	 * returns the total count of unread messages when value has been changed.
	 */
	onTotalUnreadMessagesChanges: EventEmitter<number> = new EventEmitter<number>();

	constructor(
		private spaLogger: SpaLogger,
		public _spaContext: SpaContext,
		private _spaEventService: SpaEventService,
		authContextService: AuthContextService,
	) {
		if (authContextService.isClient()) {
			this.init();
		} else {
			this._spaEventService.onSignedIn.subscribe(() => {
				this.init();
			});
		}
	}

	public init(): void {
		this.initSocket();
	}

	private initSocket(): void {
		this.conn = new xsockets.client(`wss://${location.hostname}:${environment.realtime.port}`, ['messaging']);
		this.conn.setPersistentId(xsockets.utils.guid());
		this.conn.autoReconnect(false);

		this.conn.onOpen = () => {
			this.reconectAttempts = 0;
			this.ws.publish('ping', null); // Ping the server when reconnect, so it know we're back
		};
		this.conn.onClose = () => {
			this.reconectAttempts++;
			window.setTimeout(() => {
				if (this.reconectAttempts < 30) {
					this.openSocketConnection();
				}
			}, 1000 * this.reconectAttempts);
		};

		this.ws = this.conn.controller('messaging');

		this.ws.onOpen = () => {
			this.spaLogger.log('Info', ['Messaging', 'Websocket'], 'Messaging_Websocket_Connected');
			window.onunload = () => {
				this.ws.close();
			};
		};

		this.ws.on('duplicate_connection', () => {
			this.ws = null;
			window.onbeforeunload = null;
			window.location.href = `/${µ.LicenceHolder.UrlAlias}/error/multiconnections`;
		});

		// ---- Messaging Events ----
		this.ws.on('messages', (data) => {
			this.onMessages.emit(data);
			if (data.data.some((m) => m.sender?.isMe)) {
				this.setReadUntil(data.caseId, new Date(data.data[0].timestamp));
			}
		});
		this.ws.on('getmessages_r', (data) => {
			this.onGetMessages.emit(data);
		});
		this.ws.on('has_read_until', (data) => {
			this.onHasReadUntil.emit(data);
		});
		this.ws.on('case_closed', (caseId) => {
			this.onCaseClosed.emit(caseId);
		});
		this.ws.on('allow_client_response_changed', (data: Messaging.AllowClientResponseChangedModel) => {
			this.onAllowClient.emit(data);
		});

		this.reconectAttempts = 0;
		this.openSocketConnection();
	}

	private openSocketConnection(): void {
		this.conn.open();
	}
	private send(topic, data = null): void {
		this.ws.publish(topic, data);
	}

	// ---- Private Messaging Functions ----
	public setReadUntil(caseId: number, timestamp: Date): void {
		const sendTimeStamp: Date = new Date(new Date(timestamp).getTime() + 20);
		this.send('SetReadUntil', { caseId, timestamp: sendTimeStamp });
	}
	// ---- Public Messaging Functions ----

	public sendMessage(caseId: number, text: string, files: Array<Guid> = []): void {
		this.send('SendMessage', { caseId, text, textFormat: 'Plaintext', fileTickets: files });
	}
	public getMessages(caseId: number): void {
		this.send('GetMessages', { caseId });
	}
}
